import {Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {DataService} from "@shared/services/data.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  CREATE_STORE_FORM_ACTION,
  STORE_ACTION_ENUM
} from "@app/features/store-invitation/create-store/create-store.component";
import {MapsAPILoader} from "@agm/core";

@Component({
  selector: 'app-store-location-form',
  templateUrl: './store-location-form.component.html',
  styleUrls: ['./store-location-form.component.scss']
})
export class StoreLocationFormComponent implements OnInit {
  @Output() handelAction: EventEmitter<CREATE_STORE_FORM_ACTION> = new EventEmitter<CREATE_STORE_FORM_ACTION>();
  latitude: number = 31.9037641;
  longitude: number = 35.2034184;
  zoom: number = 13;
  geoCoder: google.maps.Geocoder | undefined;
  address = 'Ramallah';
  loadAddress = false;
  public countriesList: any[] = [];
  public submitted = false;
  @ViewChild('search', {static: false}) public searchElement: ElementRef | undefined;
  @Input() data: any;

  constructor(private dataService: DataService,
              private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,
              private formBuilder: FormBuilder,) {
  }

  ngOnInit(): void {
    this.address = this.data.location.name ?? this.address;
    this.initCountries();
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
      const places = this.searchElement;
      // if (places) {
      const autocomplete = new google.maps.places.Autocomplete(places?.nativeElement ?? '');

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
    this.registerForm = this.formBuilder.group({
      country: [this.data?.location?.country.id ?? {}, [Validators.required]],
      latitude: [this.data?.location?.latitude ?? '31.9037641', [Validators.required]],
      longitude: [this.data?.location?.longitude ?? '35.2034184', [Validators.required]],
    });
  }

  public registerForm: any = FormGroup;

  get f() {
    return this.registerForm.controls;
  }

  markerDragEnd($event: any) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.registerForm.controls.longitude.setValue(this.longitude)
    this.registerForm.controls.latitude.setValue(this.latitude)
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude: number, longitude: number) {
    this.loadAddress = true;
    if (this.geoCoder)
      this.geoCoder.geocode({location: {lat: latitude, lng: longitude}}, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;

          } else {
            window.alert('No results found');
          }
        } else {

          if (status == 'ZERO_RESULTS') {
            this.address = 'location selected on the map';
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
        this.loadAddress = false;
      });
  }

  public initCountries() {
    this.dataService.getStoreCountries().subscribe((res: any) => {
        this.countriesList = res;
      },
      error => {
        console.log(error);
      })
  }

  public onSubmit(back = false) {
    this.submitted = true;
    if (back) {
      let countryObj = {};
      if (this.f.country && this.f.country.value){
        countryObj = this.getCountryById(this.f.country.value);
      }
      const action: CREATE_STORE_FORM_ACTION = {
        selectedIndex: 4,
        data: {
          country: countryObj,
          longitude: this.f.longitude.value,
          latitude: this.f.latitude.value,
          name: this.address
        },
        action: STORE_ACTION_ENUM.back
      }
      this.handelAction.emit(action);
      return;
    }
    if (this.registerForm.invalid) {
      return;
    }
    const action: CREATE_STORE_FORM_ACTION = {
      selectedIndex: 4,
      data: {
        country: this.getCountryById(this.f.country.value),
        longitude: this.f.longitude.value,
        latitude: this.f.latitude.value,
        name: this.address
      },
      action: STORE_ACTION_ENUM.next
    }
    this.handelAction.emit(action)
  }

  public getCountryById(id: any) {
    return this.countriesList.find(x => x.id == id);
  }
}
